import { createContext } from "react";

export const AuthContext = createContext({
  isLoggedIn: false,
  userId: null,
  loggedUserData: null,
  authLoading: true,
  token: null,
  login: () => {},
  logout: () => {},
});
